import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/overrides/')({
  component: () => <Navigate to="/overrides/session" />,
});
